module.exports = __webpack_public_path__ + "static/media/player_30p.84e8794e.png";